import { LogoMark } from "./icons";
import type { Theme } from "./theme";

export function FooterFull({
  theme,
  signInUrl,
  currentUser,
  copyrightYear,
}: {
  theme: Theme;
  signInUrl: string;
  currentUser: { name: string; appUrl: string } | null;
  copyrightYear: number;
}) {
  return (
    <footer
      style={{
        padding: "72px 0 48px",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 40px" }}>
        <p
          style={{
            fontSize: 20,
            color: theme.fg,
            lineHeight: 1.45,
            maxWidth: 720,
            letterSpacing: -0.3,
            marginBottom: 48,
          }}
        >
          Rarion enables organisations to make better hiring decisions through structured
          collaboration, consistent evaluation, and expert-informed frameworks — while reducing
          reliance on external agencies.
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            paddingTop: 32,
            borderTop: `1px solid ${theme.border}`,
          }}
        >
          <LogoMark theme={theme} size={20} />
          <div style={{ fontSize: 14, color: theme.fgMute }}>© {copyrightYear} Rarion</div>
          <div style={{ flex: 1 }} />
          {currentUser ? (
            <a
              href={currentUser.appUrl}
              style={{ fontSize: 14, color: theme.fgMute, textDecoration: "none" }}
            >
              Open Rarion
            </a>
          ) : (
            <a
              href={signInUrl}
              style={{ fontSize: 14, color: theme.fgMute, textDecoration: "none" }}
            >
              Sign in
            </a>
          )}
        </div>
      </div>
    </footer>
  );
}
